import React from 'react';

interface PlayProps {
  size?: number;
}

export const Play = ({ size = 48 }: PlayProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M24 48C20.7216 48 17.6314 47.3726 14.7294 46.1176C11.8431 44.8627 9.29412 43.1294 7.08235 40.9176C4.87059 38.7059 3.13725 36.1569 1.88235 33.2706C0.627451 30.3686 0 27.2784 0 24C0 20.7216 0.627451 17.6392 1.88235 14.7529C3.13725 11.851 4.86275 9.29412 7.05882 7.08235C9.27059 4.87059 11.8196 3.13725 14.7059 1.88235C17.6078 0.627451 20.698 0 23.9765 0C27.2549 0 30.3451 0.627451 33.2471 1.88235C36.149 3.13725 38.7059 4.87059 40.9176 7.08235C43.1294 9.29412 44.8627 11.851 46.1176 14.7529C47.3726 17.6392 48 20.7216 48 24C48 27.2784 47.3726 30.3686 46.1176 33.2706C44.8627 36.1569 43.1294 38.7059 40.9176 40.9176C38.7059 43.1294 36.149 44.8627 33.2471 46.1176C30.3608 47.3726 27.2784 48 24 48ZM19.5294 33.4824L33.3647 25.3412C33.6941 25.1373 33.9137 24.8706 34.0235 24.5412C34.1333 24.1961 34.1333 23.8588 34.0235 23.5294C33.9137 23.1843 33.6941 22.9176 33.3647 22.7294L19.5294 14.5412C19.1843 14.3373 18.8235 14.251 18.4471 14.2824C18.0706 14.3137 17.749 14.4392 17.4824 14.6588C17.2314 14.8784 17.1059 15.1843 17.1059 15.5765V32.4471C17.1059 32.8392 17.2314 33.1529 17.4824 33.3882C17.7333 33.6235 18.0392 33.7569 18.4 33.7882C18.7765 33.8196 19.1529 33.7176 19.5294 33.4824Z'
      fill='var(--t3k-accent)'
    />
  </svg>
);
